<template>
  <div>
    <v-container>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-container>

    <ag-grid-vue
      style="width: 100%; padding: 5px"
      class="ag-theme-balham mt-2 mb-4"
      domLayout="autoHeight"
      :columnDefs="columnDefs"
      :rowData="distinctCustomers"
      :defaultColDef="defaultColDef"
      :frameworkComponents="frameworkComponents"
      rowSelection="single"
      @grid-ready="onGridReady"
      :paginationPageSize="10"
      pagination
      :gridOptions="gridOptions"
    ></ag-grid-vue>
    <v-snackbar v-model="snackbar" :timeout="5000" :color="snackColor">
      {{ message }}
    </v-snackbar>
    <loader-dialog :showLoader="isLoading" :stockDialog="true"></loader-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { mapDistinctCustomersFields } from '@/store/modules/distinctCustomers';
const { mapActions: mapDistinctCustomersActions } =
  createNamespacedHelpers('distinctCustomers');
import { AgGridVue } from 'ag-grid-vue';
import AddDelearButton from './link-managemen/add-dealer-button';
import LoaderDialog from '@/components/common/LoaderDialog';

export default {
  name: 'LinkManagement',
  components: {
    AgGridVue,
    AddDelearButton,
    LoaderDialog,
  },
  data: () => ({
    gridOptions: null,
    columnDefs: null,
    defaultColDef: null,
    gridApi: null,
    frameworkComponents: null,
    snackbar: false,
    snackColor: '',
    isLoading: false,
    search: '',
  }),
  computed: {
    ...mapDistinctCustomersFields(['message', 'distinctCustomers']),
  },

  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: 'Customer Number',
        field: 'customerNumber',
        sortable: true,
        filter: true,
        maxWidth: 100,
      },
      {
        headerName: 'Contact Email',
        field: 'contactEmail',
        sortable: true,
        filter: true,
        maxWidth: 250,
      },
      {
        headerName: 'Agent Number',
        field: 'agentNo',
        sortable: true,
        filter: true,
        maxWidth: 100,
      },
      {
        headerName: 'Agent Name',
        field: 'agentName',
        sortable: true,
        filter: true,
        maxWidth: 200,
      },
      {
        headerName: 'Group Number',
        field: 'groupNo',
        sortable: true,
        filter: true,
        maxWidth: 100,
      },
      {
        headerName: 'Group Name',
        field: 'groupName',
        sortable: true,
        filter: true,
        maxWidth: 200,
      },
      {
        headerName: 'First Name',
        field: 'firstname',
        sortable: true,
        filter: true,
        maxWidth: 150,
      },
      {
        headerName: 'Surname',
        field: 'surname',
        sortable: true,
        filter: true,
        maxWidth: 150,
      },
      {
        headerName: 'Action',
        cellRenderer: 'addDelearButton',
        suppressSizeToFit: true,
        width: 400,
        cellRendererParams: {
          clicked: function (param) {
            vm.showConfirmDialog(param);
          },
          updatePBX: function (param) {
            vm.updatePBX(param);
          },
        },
      },
    ];
    vm.frameworkComponents = { addDelearButton: AddDelearButton };
    vm.defaultColDef = {
      autoHeight: true,
    };
    vm.isLoading = true;
    vm.getDistinctCustomers()
      .then(() => {
        vm.isLoading = false;
      })
      .catch((err) => {
        vm.isLoading = false;
      });
  },
  methods: {
    ...mapDistinctCustomersActions([
      'getDistinctCustomers',
      'createCustomerLogin',
      'updatePBXDomain',
    ]),
    onGridReady(params) {
      let vm = this;
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    },
    toggleSnackbar(message, color) {
      const vm = this;
      vm.snackbar = true;
      vm.snackColor = color;
      vm.message = message;
    },
    updatePBX(param) {
      const vm = this;
      vm.$dialog
        .confirm('Confirm Update HostedPBXDomain')
        .then(async () => {
          vm.isLoading = true;
          vm.updatePBXDomain(param.customerNumber)
            .then((res) => {
              vm.isLoading = false;
              vm.toggleSnackbar('OK', 'success');
            })
            .catch((err) => {
              vm.isLoading = false;
              vm.toggleSnackbar('OK', err.response.data.message);
            });
        })
        .catch((err) => {
          vm.isLoading = false;
          vm.toggleSnackbar(err.response.data.message, 'error');
        });
    },
    showConfirmDialog(data) {
      let vm = this;
      vm.$dialog
        .confirm('Are you sure you want to create login for this customer?')
        .then(async () => {
          let res = await vm.createCustomerLogin({
            tempCustomer: data,
          });
          if (res.success == true) {
            vm.toggleSnackbar(res.data.message, 'success');
          }
        })
        .catch((err) => {
          vm.toggleSnackbar(err.response.data.message, 'error');
        });
    },
  },
  watch: {
    search(val) {
      this.gridOptions.api.setQuickFilter(val);
    },
  },
};
</script>
